

















































































import AbpBase from "../lib/abpbase";
import { Component, Prop, Model, Emit } from "vue-property-decorator";

@Component
export default class QueryBoard extends AbpBase {
  @Prop()
  value: any;

  initValue: any = [];
  queryValue: any = [];
  show: Boolean = false;

  created() {
    this.initValue = JSON.parse(JSON.stringify(this.value));
    this.queryValue = JSON.parse(JSON.stringify(this.value));
  }

  advancedSearch() {
    this.queryValue = JSON.parse(JSON.stringify(this.initValue));
    this.show = true;
  }

  query() {
    this.initValue = JSON.parse(JSON.stringify(this.queryValue));
    this.show = false;
    this.$emit("query", this.queryValue);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/query-board.vue